
import { defineComponent } from "vue";
import { IJBACombinedRisk } from "@/types";

export default defineComponent({
  name: "FloodClimateChangeRisks",
  props: {
    scores: {
      type: Object as () => IJBACombinedRisk,
      required: true,
    },
  },
  computed: {
    floodRiskTypes(): any[] {
      return [
        {
          name: "Coastal",
          icon: require("@/assets/icons/coastal.svg"),
          value: this.scores.CombinedScoreCoastal
            ? this.scores.CombinedScoreCoastal
            : 0,
        },
        {
          name: "River",
          icon: require("@/assets/icons/river.svg"),
          value: this.scores.CombinedScoreRiver
            ? this.scores.CombinedScoreRiver
            : 0,
        },
        {
          name: "SurfaceWater",
          icon: require("@/assets/icons/surfaceWater.svg"),
          value: this.scores.CombinedScoreSurfaceWater
            ? this.scores.CombinedScoreSurfaceWater
            : 0,
        },
      ];
    },
  },
});
